import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Browser from '@wetransfer/concorde-browser';

import Actions from '@app/store/action';

import { userNeedsTips } from '@app/helper/user';

import TextArea from '@component/form/element/textarea';

export class Message extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.defaultValue || '',
    };

    this.textareaRef = React.createRef();
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  focus() {
    this.textareaRef &&
      this.textareaRef.current &&
      this.textareaRef.current.focus();
  }

  onChange(e) {
    this.props.onChange(e.target.value);
    this.setState({ value: e.target.value });
  }

  onFocus() {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
    if (!userNeedsTips(this.props.user)) {
      return;
    }
    this.props.pushTransferNotification({ text: 'TipMessage' });
  }

  onBlur() {
    if (!userNeedsTips(this.props.user)) {
      return;
    }

    this.props.clearTransferNotification();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: this.props.defaultValue });
    }
    if (prevState.value === this.state.value) {
      return;
    }
    if (
      this.textareaRef.current.selectionStart !==
      this.textareaRef.current.value.length
    ) {
      return;
    }
    // on mobile we don't have the panel prop and don't need to scroll
    if (this.props.panel) {
      this.props.panel.scrollTo('bottom');
    }
  }

  render() {
    const messageShadow = (
      <div className="uploader__message--shadow">
        {this.state.value.replace(/\n$/, '\n ')}
      </div>
    );
    return (
      <div className="uploader__message">
        <TextArea
          name="message"
          hideLabelOnInput={!Browser.isMobile}
          content={messageShadow}
          className="textarea--noborder"
          textareaRef={this.textareaRef}
          label={this.props.placeholder}
          value={this.state.value}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          resizeOnUpdate={false}
        />
      </div>
    );
  }
}

Message.propTypes = {
  clearTransferNotification: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  panel: PropTypes.object,
  placeholder: PropTypes.string,
  user: PropTypes.object.isRequired,
  pushTransferNotification: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({ user: state.user });

const mapDispatchToProps = {
  clearTransferNotification: Actions.Notification.clearTransfer,
  pushTransferNotification: Actions.Notification.pushTransfer,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Message);
